"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XoneError = void 0;
var XoneError = /** @class */ (function () {
    function XoneError() {
    }
    XoneError.prototype.clear = function () {
    };
    XoneError.prototype.getDescription = function () {
        return this.m_description;
    };
    XoneError.prototype.getFailedSql = function () {
        return this.m_failedSql;
    };
    XoneError.prototype.setFailedSql = function (failedSql) {
        this.m_failedSql = failedSql;
    };
    XoneError.prototype.getNumber = function () {
        return this.m_code;
    };
    XoneError.prototype.setNumber = function (code) {
        this.m_code = code;
    };
    XoneError.prototype.setDescription = function (description) {
        this.m_description = description;
    };
    return XoneError;
}());
exports.XoneError = XoneError;

//# sourceMappingURL=XoneError.js.map
